import "./about.css";

function About() {
    return (
        <div className="aboutCont flex" id="nosotros">
            <div className="aboutLeftCont flex">
                <div className="aboutLeftBottomTextCont flex column">
                    <p className="aboutLeftBottomText1">ITERPROS</p>  
                    <p className="aboutLeftBottomText2">INGENIERIA EXITOSA</p>
                </div>
            </div>
            <div className="aboutRightCont flex column">
                <img src="/images/backgrounds/about.jpg" alt="Fondo sección Nosotros" className="aboutRightBgImage"/>
                <p>Somos un equipo de ingenieros civiles apasionados en hacer las cosas bien.</p>
                <p>Tenemos más de 15 años de experiencia en la industria de la construcción en las áreas de planificación, proyecto, dirección, ejecución y mantenimiento de obras comerciales, industriales y públicas.</p>
                <p>Creamos valor en virtud de las mejores prácticas, adecuados a normativas y reglamentos vigentes.</p>
                <p>Hablamos claro y trabajamos duro.</p> 
                <p>Nuestro objetivo es que nuestros clientes tengan el mayor equilibrio entre rentabilidad económica y seguridad.</p>
                <img src="/images/logo2.png" alt="Logo" className="aboutLogo"/>
            </div>
        </div>
    );
}

export default About;